// removed by extract-text-webpack-plugin
module.exports = {"trending":"_2duXQ"};